import React, { useState } from "react";
import { Col_12_8_6_4 } from "../../../../components/col/Col_12_8_6_4";
import LabelValor from "../../../../components/label/LabelValor";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";
import { Select, Modal } from "antd";

export const TipoGrua = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [data, setNewData] = useState();
  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );

  const handleOpen = () => {
    setNewData(c.tipoGrua || undefined);
    setOpen(true);
  };

  const HandleOk = () => {
    dispatch(startUpdateServicio({ tipoGrua: data }, id));
    setOpen(false);
  };

  return (
    <>
      <Col_12_8_6_4>
        <LabelValor
          labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
          label="Tipo Grúa"
          valor={c.tipoGrua ? c.tipoGrua.charAt(0).toUpperCase() + c.tipoGrua.slice(1) : ""}
          onClick={handleOpen}
        />
      </Col_12_8_6_4>
      <Modal
        title="Establecer Tipo Grúa"
        onCancel={() => setOpen(false)}
        onOk={HandleOk}
        open={open}
      >
        <Select
          style={{ width: "100%" }}
          placeholder="Selecciona una opción"
          value={data || undefined}
          onChange={setNewData}
          allowClear
          options={[
            { label: "A", value: "a" },
            { label: "B", value: "b" },
            { label: "C", value: "c" },
            { label: "D", value: "d" },
          ]}
        />
      </Modal>
    </>
  );
};
